import React, { useState } from 'react';
import { Briefcase } from 'lucide-react';
import { ExperienciaLaboral } from './../../objetos/objeto_tutor';
import { formatearFechaCompleta } from '../../utils/utils';
import ListaExperienciaLaboral from './listaExperienciaLaboral';

const ExperienciaLaboralForm = ({ formData, setFormData }) => {
  const [nuevaExperiencia, setNuevaExperiencia] = useState({
    nombrEmpresa: '',
    modalidad: '',
    fechaIncio: '',
    fechaFinal: '',
    trabajandoActualmente: false,
    descripcion: ''
  });
  
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    
    if (type === 'checkbox') {
      setNuevaExperiencia({
        ...nuevaExperiencia,
        [id]: checked
      });
    } else {
      setNuevaExperiencia({
        ...nuevaExperiencia,
        [id]: value
      });
    }
  };

  const validarFormulario = () => {
    if (!nuevaExperiencia.nombrEmpresa) {
      setError('El nombre de la empresa es obligatorio');
      return false;
    }
    if (!nuevaExperiencia.modalidad) {
      setError('Debes seleccionar una modalidad');
      return false;
    }
    if (!nuevaExperiencia.fechaIncio) {
      setError('La fecha de inicio es obligatoria');
      return false;
    }
    if (!nuevaExperiencia.trabajandoActualmente && !nuevaExperiencia.fechaFinal) {
      setError('Debes proporcionar una fecha de finalización o marcar como trabajo actual');
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    setError('');
    
    if (!validarFormulario()) {
      return;
    }

    // Crear una nueva instancia de ExperienciaLaboral
    const nuevaExp = new ExperienciaLaboral({
      nombrEmpresa: nuevaExperiencia.nombrEmpresa,
      modalidad: nuevaExperiencia.modalidad,
      fechaIncio: nuevaExperiencia.fechaIncio,
      fechaFinal: nuevaExperiencia.fechaFinal,
      trabajandoActualmente: nuevaExperiencia.trabajandoActualmente,
      descripcion: nuevaExperiencia.descripcion
    });

    // Actualizar el formData
    setFormData({
      ...formData,
      experienciaLaboral: [...formData.experienciaLaboral, nuevaExp]
    });

    // Limpiar el formulario
    setNuevaExperiencia({
      nombrEmpresa: '',
      modalidad: '',
      fechaIncio: '',
      fechaFinal: '',
      trabajandoActualmente: false,
      descripcion: ''
    });
  };

  const eliminarExperiencia = (index) => {
    const expActualizada = [...formData.experienciaLaboral];
    expActualizada.splice(index, 1);
    setFormData({...formData, experienciaLaboral: expActualizada});
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center text-xl font-bold text-gray-800 mb-4">
        <Briefcase className="mr-3 w-6 h-6 text-blue-500" />
        Experiencia Laboral
        <span className="ml-2 text-sm font-normal text-gray-500">(Opcional)</span>
      </div>
      
      <p className="text-gray-600 mb-4">
        Añade tu experiencia laboral relacionada con la enseñanza o tu área de especialidad.
      </p>
      
      <ListaExperienciaLaboral
         experienciaLaboral={formData.experienciaLaboral}
         oneliminarExperiencia={eliminarExperiencia}
       />
      
      {/* Formulario para añadir experiencia */}
      <div className="border rounded-lg p-4">
        <h3 className="font-semibold mb-4">Añadir Experiencia</h3>
        
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mb-4">
            {error}
          </div>
        )}
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Nombre de la Empresa
            </label>
            <input 
              type="text" 
              className="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              id="nombrEmpresa"
              placeholder="Ej: Universidad XYZ"
              value={nuevaExperiencia.nombrEmpresa}
              onChange={handleChange}
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Modalidad
            </label>
            <select 
              className="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              id="modalidad"
              value={nuevaExperiencia.modalidad}
              onChange={handleChange}
            >
              <option value="">Seleccionar...</option>
              <option value="Presencial">Presencial</option>
              <option value="Remoto">Remoto</option>
              <option value="Híbrido">Híbrido</option>
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Fecha de Inicio
            </label>
            <input 
              type="date" 
              className="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              id="fechaIncio"
              value={nuevaExperiencia.fechaIncio}
              onChange={handleChange}
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Fecha de Finalización
            </label>
            <div className="space-y-2">
              <div className="flex items-center">
                <input 
                  type="checkbox" 
                  id="trabajandoActualmente" 
                  className="mr-2 h-4 w-4"
                  checked={nuevaExperiencia.trabajandoActualmente}
                  onChange={handleChange}
                />
                <label htmlFor="trabajandoActualmente" className="text-sm">Trabajo actual</label>
              </div>
              <input 
                type="date" 
                className="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                id="fechaFinal"
                value={nuevaExperiencia.fechaFinal}
                onChange={handleChange}
                disabled={nuevaExperiencia.trabajandoActualmente}
              />
            </div>
          </div>
          
          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Descripción de trabajo
            </label>
            <textarea 
              className="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 h-24"
              id="descripcion"
              placeholder="Describe tus responsabilidades y logros..."
              value={nuevaExperiencia.descripcion}
              onChange={handleChange}
            ></textarea>
          </div>
        </div>
        
        <button 
          className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 w-full"
          onClick={handleSubmit}
        >
          Añadir Experiencia
        </button>
      </div>
      
      <div className="text-sm bg-blue-50 p-4 rounded-lg border-2 border-dashed border-blue-200">
        <p className="font-bold text-blue-700 mb-1">✓ PASO OPCIONAL</p>
        <p className="text-gray-600">
          Este paso no es obligatorio para completar tu registro. Sin embargo, añadir tu experiencia laboral puede ayudarnos a ver tu perfil profesional .
        </p>
      </div>
    </div>
  );
};

export default ExperienciaLaboralForm;